import { useNavigate } from 'react-router-dom'
import { DropdownMenu, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import UnholsterLogo from '@/assets/UnholsterLogo_svg'

function Organization() {
  const navigate = useNavigate()
  return (
    <DropdownMenu>
      <DropdownMenuTrigger onClick={() => navigate('/')}>
        <div className="flex items-center justify-center w-30 h-10">
          {<UnholsterLogo />}
        </div>
      </DropdownMenuTrigger>
    </DropdownMenu>
  )
}
export { Organization }
